import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import LineBtn from "../../components/Button/LineBtn";
import Flex from "../../components/DefaultStyles/Flex";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import Search from "../../components/Filters/Search";
import AlertModal from "../../components/Modal/AlertModal";
import ManageModal from "../../components/pages/Manage/ManageAuth/ManageModal";
import ManagerDeleteModal from "../../components/pages/Manage/ManageAuth/ManagerDeleteModal";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import ManagerAuthModal from "../../components/pages/Manage/ManageAuth/ManagerAuthModal";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import GradeAddBtn from "../../components/pages/Manage/ManageAuth/GradeEdit/GradeAddBtn";
import GradeDeleteBtn from "../../components/pages/Manage/ManageAuth/GradeEdit/GradeDeleteBtn";
import { PartyInfoFilterContainer } from "../../components/pages/Party/PartyInfo/PartyInfoFilter";
import useGradeList from "../../hooks/useGradeList";
import Loader from "../../components/DefaultStyles/Loader";
import useMy from "../../hooks/useMy";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authType } from "../Login";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { TotalCount } from "../Users/UserInfo";
import { getThousandComma } from "../../Api/ApiCommon";

interface IAdmin {
  id: string;
  grade: string;
  indate: string;
  name: string;
  email: string;
}

export interface ManagerDataProps {
  id: string;
  name: string;
  email: string;
  grade: string;
  gradeString?: string;
}

export default function ManageAuth() {
  const { grade } = useMy();

  const auth = useRecoilValue(authType);
  const setAuth = useSetRecoilState(authType);
  const [saveRecoil, setSaveRecoil] = useState(false);
  const [page, setPage] = useState(0);
  const [authDropdown, setAuthDropdown] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [authSearchValue, setAuthSearchValue] = useState<string | undefined>(
    ""
  );

  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteAlertModal, setDeleteAlertModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [authModal, setAuthModal] = useState(false);

  const gradeList = useGradeList();

  const [gradeName, setGradeName] = useState("");
  const [managerData, setManagerData] = useState<ManagerDataProps>({
    id: "",
    name: "",
    email: "",
    grade: "",
    gradeString: "",
  });

  const { response, fetchData, loading } = useApi({
    method: "get",
    url:
      `admin?page=${page}&size=10` +
      (authSearchValue ? `&${authDropdown?.value}=${authSearchValue}` : ``),
  });

  const tableHead = ["No", "이름", "Email", "등급", "등록일", "변경", "삭제"];

  const authOptionList = [
    { value: "name", label: "이름" },
    { value: "email", label: "email" },
  ];

  const { response: authResponse, loading: authLoading } = useApi({
    method: "get",
    url: grade && saveRecoil ? `auth/detail?id=${grade}` : undefined,
  });

  useEffect(() => {
    if (authResponse?.status === 200) {
      setAuth(authResponse?.data[0]);
      setSaveRecoil(false);
    }
  }, [authResponse]);

  useEffect(() => {}, [saveRecoil]);

  return (
    <>
      <PageTitle title="관리자 권한 관리" />

      <PartyInfoFilterContainer>
        <Flex gapSize={10}>
          <DropDown
            setDropDownValue={setAuthDropdown}
            dropdownValue={authDropdown}
            boxWidth={140}
            optionList={authOptionList}
          />

          <Search
            setSearchValue={setAuthSearchValue}
            placeholder="입력"
            pageResetEvent={() => setPage(0)}
          />
        </Flex>

        <Flex gapSize={10}>
          {/* 등급 추가 버튼 */}
          <GradeAddBtn
            authModalOpenEvent={(name) => {
              setAuthModal(true);
              setGradeName(name);
            }}
          />

          {/* 등급 삭제 버튼 */}
          <GradeDeleteBtn />

          <LineBtn
            btnText="등급 별 권한 설정"
            icon="gpp_good"
            btnHeight={38}
            btnClickEvent={() => setAuthModal(true)}
            disabled={!auth?.adminSet}
          />

          <LineBtn
            btnText="관리자 추가"
            icon="add"
            btnHeight={38}
            btnClickEvent={() => setAddModal(true)}
            disabled={!auth?.adminSet}
          />
        </Flex>
      </PartyInfoFilterContainer>

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {response?.data?.items?.map((d: IAdmin) => {
              return (
                <TableBody key={d.id}>
                  <TableBodyItem>{d?.id}</TableBodyItem>
                  <TableBodyItem>{d?.name}</TableBodyItem>
                  <TableBodyItem>{d?.email}</TableBodyItem>
                  <TableBodyItem>
                    {
                      gradeList?.find(
                        (val) =>
                          val?.value === String(d?.grade) ||
                          val?.value === d?.grade ||
                          String(val?.value) === d?.grade
                      )?.label
                    }
                  </TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.indate)?.format("YYYY-MM-DD")}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="변경"
                      btnClickEvent={() => {
                        setManagerData({
                          id: d?.id,
                          name: d?.name,
                          email: d?.email,
                          grade: d?.grade,
                          gradeString: gradeList?.find(
                            (val) =>
                              val?.value === String(d?.grade) ||
                              val?.value === d?.grade ||
                              String(val?.value) === d?.grade
                          )?.label,
                        });
                        setEditModal(true);
                      }}
                      disabled={!auth?.adminSet}
                    />
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="삭제"
                      btnClickEvent={() => {
                        setManagerData({
                          id: d?.id,
                          name: d?.name,
                          email: d?.email,
                          grade: d?.grade,
                          gradeString: gradeList?.find(
                            (val) =>
                              val?.value === String(d?.grade) ||
                              val?.value === d?.grade ||
                              String(val?.value) === d?.grade
                          )?.label,
                        });
                        setDeleteAlertModal(true);
                      }}
                      disabled={!auth?.adminSet}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>

        <>
          {/* 관리자 추가 모달 */}
          {addModal && (
            <ManageModal
              closeEvent={() => setAddModal(false)}
              updateEvent={() =>
                fetchData({
                  method: "get",
                  url:
                    `admin?page=${page}&size=10` +
                    (authSearchValue
                      ? `&${authDropdown?.value}=${authSearchValue}`
                      : ``),
                })
              }
            />
          )}

          {/* 관리자 변경 모달 */}
          {editModal && (
            <ManageModal
              closeEvent={() => setEditModal(false)}
              managerData={managerData}
              updateEvent={() => {
                fetchData({
                  method: "get",
                  url:
                    `admin?page=${page}&size=10` +
                    (authSearchValue
                      ? `&${authDropdown?.value}=${authSearchValue}`
                      : ``),
                });
              }}
            />
          )}

          {/* 관리자 삭제 Alert 모달 */}
          {deleteAlertModal && (
            <AlertModal
              title={`${managerData?.name}님의 링키드 어드민 접근 권한이 삭제됩니다. 
      계속하시겠습니까?
      `}
              cancelEvent={() => setDeleteAlertModal(false)}
              confirmText="삭제"
              confirmEvent={() => {
                setDeleteAlertModal(false);
                setDeleteModal(true);
              }}
            />
          )}

          {/* 관리자 삭제 모달 */}
          {deleteModal && (
            <ManagerDeleteModal
              closeEvent={() => setDeleteModal(false)}
              managerData={managerData}
              updateEvent={() => {
                fetchData({
                  method: "get",
                  url:
                    `admin?page=${page}&size=10` +
                    (authSearchValue
                      ? `&${authDropdown?.value}=${authSearchValue}`
                      : ``),
                });
              }}
            />
          )}

          {/* 등급 별 권한 설정 모달 */}
          {authModal && (
            <ManagerAuthModal
              closeEvent={() => setAuthModal(false)}
              confirmEvent={() => {
                setSaveRecoil(true);
              }}
              gradeName={gradeName}
            />
          )}
        </>
      </LineBox>

      <ExcelDownload
        tableHead={["No", "이름", "Email", "등급", "등록일", "-"]}
        pushedData={(e: any) => {
          return [
            e.id,
            e?.name,
            e.email,
            gradeList?.find(
              (val) =>
                val?.value === e?.grade ||
                val?.value === String(e?.grade) ||
                String(val?.value) === e?.grade
            )?.label,
            dayjs(e?.indate)?.format("YYYY-MM-DD"),
          ];
        }}
        dataUrl={
          `admin?page=0&size=100` +
          (authSearchValue ? `&${authDropdown?.value}=${authSearchValue}` : ``)
        }
        disabled={response?.data?.items?.length < 1 || !response}
        title="관리자 계정 관리"
      />

      {(loading || authLoading) && <Loader />}
    </>
  );
}
